<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'SALES_DOCUMENT|Modyfikacja zamówienia' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <p>{{ 'SALES_DOCUMENT|Uwaga! Zamówienie zostanie usunięte z kolejki produkcyjnej i będzie konieczna ponowna rezerwacja terminu dostawy.' | translate }}</p>
        <p>{{ 'SALES_DOCUMENT|Aby kontynuować należy zdecydować czy kupujący również może edytować to zamówienie:' | translate }}</p>
    </div>
    <div class="dialog-footer flex-vertical">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
                [disabled]="inProgress"
            >
                {{ 'INTERFACE|Anuluj' | translate}}
            </button>

            <div class="right">
                <span class="space"></span>
                <button iccButton (click)="modify('sales')" [disabled]="!canBeModified">{{ 'SALES_DOCUMENT|Tylko sprzedający' | translate}}</button>
                <button iccButton (click)="modify('all')" [disabled]="!canBeModified">{{ 'SALES_DOCUMENT|Edycja również przez kupującego' | translate}}</button>
            </div>

        </div>
        <div class="w-100" *ngIf="!messages.length && message">
            <p [class.error]="messageState === 'error'" class="dialog-message">{{ message }}</p>
        </div>
        <div class="w-100" *ngIf="messages.length">
            <p [class.error]="messageState === 'error'" class="dialog-message" *ngFor="let msg of messages">{{ msg }}</p>
        </div>
    </div>
</div>
<div
    class="curtain"
    (click)="close()"
></div>
